import React, { useState, useEffect } from 'react'

import HoverTooltip from '../../../../../../components/HoverTooltip'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'
import CurrencyExchangeRateInput from '../../../../../../components/currency/CurrencyExchangeRateInput'
import Section from '../../../../../../components/Section'
import {
    Contract,
    ContractPerformance,
    LongTermContractVolumes,
} from '../../../types'

import { CurrencyList } from '../../../../Plans/Positions/Edit/types'

import {
    purchaseTypeInfo,
    purchaseInfo,
    planInfo,
    ContractPurchaseInfoError,
    ContractBaseInfoError,
} from '../types'

import Checkbox from '../../../../../../components/form/Checkbox'

type Props = {
    theme: string
    contractAction: boolean
    contractGuid: string | undefined
    currencyData: CurrencyList[]
    contractPrice: number | undefined
    contractRubPrice: number | null | undefined
    contractsLoading: boolean
    contractsError: string | null
    contract: Contract
    onContractDate: (contract_date: string | null) => void
    onNumber: (lot_44_num: string | null) => void
    onSubject: (subject_contract: string | null) => void
    onCurrencyChange: (value: number) => void
    errors?: ContractBaseInfoError

    currency: number | null
    currencyExchangeRate?: number
    onCurrencyExchangeRateChange?: (value: number) => void
    price: number
    onPrice: (price: number) => void
    onStartExecutionDate: (start_execution_date: string | null) => void
    onEndExecutionDate: (end_execution_date: string | null) => void
    onAdditionalInfo: (additional_info: string | null) => void
    onSubcontractor: (has_subcontractor: boolean) => void
    onSubcontractorTotal: (subcontractors_total: number | null) => void
    isChangingCurrency: boolean
}

const _maybeGetCurrencyConversionInfo = (props: Props) => {
    if (
        props.currency !== 643 &&
        props.currencyExchangeRate &&
        props.onCurrencyExchangeRateChange
    ) {
        return (
            <div className="flex flex-row items-start justify-start gap-5 h-fit">
                <div className="flex flex-col min-w-[200px]">
                    <CurrencyExchangeRateInput
                        value={props.currencyExchangeRate ?? 0}
                        onChange={props.onCurrencyExchangeRateChange}
                    />
                </div>
                <div className="flex flex-col min-w-[200px]">
                    <span className="text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Цена договора (руб.)
                    </span>
                    <MoneyInput
                        value={props.contract?.rub_price || 0}
                        disabled={true}
                        className={`form-input px-2 py-1 h-[28px] rounded-md text-sm ${
                            props.errors?.price
                                ? 'border border-[#C15C5C]'
                                : 'border border-[#2A282B]'
                        }`}
                    />
                </div>
            </div>
        )
    }
}

const ContractBaseInfo: React.FC<Props> = (props) => {
    useEffect(() => {
        console.log(props.contractAction)
    }, [])

    return (
        <Section title="Информация о договоре">
            <fieldset disabled={props.contractAction}>
                <div className="flex flex-col w-full gap-3 items-start justify-start ">
                    <div className="flex flex-row w-full gap-x-5 items-start justify-start ">
                        <div className="flex flex-col w-[200px] ">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Номер договора
                            </label>
                            <input
                                type="text"
                                className={`form-input user-input-placeholder w-full`}
                                value={
                                    props.contract?.contract_name
                                        ? props.contract?.contract_name
                                        : ''
                                }
                                style={{
                                    colorScheme:
                                        props.theme == 'dark'
                                            ? 'dark'
                                            : 'light',
                                }}
                                onChange={(e) => {
                                    e.target.value == ''
                                        ? props.onNumber(null)
                                        : props.onNumber(e.target.value)
                                }}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Дата заключения договора{' '}
                                <span className="text-[#FF0000]">*</span>
                            </label>
                            <HoverTooltip
                                tooltipText={props.errors?.contract_date || ''}
                            >
                                <input
                                    type="date"
                                    className={`form-input user-input-placeholder w-[200px]  ${
                                        props.errors?.contract_date
                                            ? 'border border-[#C15C5C] rounded-md p-2'
                                            : ''
                                    }`}
                                    value={props.contract?.contract_date ?? ''}
                                    onChange={(e) => {
                                        e.target.value == ''
                                            ? props.onContractDate(null)
                                            : props.onContractDate(
                                                  e.target.value
                                              )
                                    }}
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                />
                            </HoverTooltip>
                        </div>
                    </div>
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Предмет договора{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <HoverTooltip
                            tooltipText={props.errors?.subject_contract || ''}
                        >
                            <textarea
                                className={`form-textarea w-full ${
                                    props.errors?.subject_contract
                                        ? 'border border-[#C15C5C]'
                                        : ''
                                }`}
                                maxLength={2000}
                                rows={3}
                                value={props.contract?.subject_contract || ''}
                                onChange={(e) =>
                                    props.onSubject(e.target.value)
                                }
                            />
                        </HoverTooltip>
                    </div>
                    <div className="flex flex-row w-full gap-x-5 items-start justify-start h-fit">
                        <div className="flex flex-col w-[200px] ">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Цена договора{' '}
                                <span className="text-[#FF0000]">*</span>
                            </label>
                            <MoneyInput
                                value={props.price}
                                onChange={props.onPrice}
                                className={`form-input ${
                                    props.errors?.price
                                        ? 'border border-[#C15C5C]'
                                        : ''
                                }`}
                            />
                        </div>
                        <div className="flex flex-row items-start justify-start gap-5 h-fit">
                            <div className="relative flex flex-row min-w-[200px]">
                                <div className="flex flex-col w-[200px]">
                                    <CurrencySelector
                                        value={
                                            props.contract
                                                .currency_digital_code !== null
                                                ? String(
                                                      props.contract
                                                          .currency_digital_code
                                                  )
                                                : ''
                                        }
                                        currencyData={props.currencyData}
                                        onChange={props.onCurrencyChange}
                                    />
                                </div>
                                {props.isChangingCurrency && (
                                    <svg
                                        className={`absolute right-0 animate-spin h-4 w-4 ${
                                            props.theme === 'dark'
                                                ? 'text-[#FFFFFF]'
                                                : 'text-[#181818]'
                                        }`}
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                )}
                            </div>

                            {_maybeGetCurrencyConversionInfo(props)}
                        </div>
                    </div>
                    <div className="flex flex-row w-full gap-x-5 items-start justify-start h-fit">
                        <div className="flex flex-col">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Дата начала исполнения{' '}
                                <span className="text-[#FF0000]">*</span>
                            </label>
                            <HoverTooltip
                                tooltipText={
                                    props.errors?.start_execution_date || ''
                                }
                            >
                                <input
                                    type="date"
                                    className={`form-input user-input-placeholder w-[200px]  ${
                                        props.errors?.start_execution_date
                                            ? 'border border-[#C15C5C] rounded-md p-2'
                                            : ''
                                    }`}
                                    value={
                                        props.contract?.start_execution_date ??
                                        ''
                                    }
                                    onChange={(e) => {
                                        e.target.value == ''
                                            ? props.onStartExecutionDate(null)
                                            : props.onStartExecutionDate(
                                                  e.target.value
                                              )
                                    }}
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                />
                            </HoverTooltip>
                        </div>
                        <div className="flex flex-col">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Дата окончания исполнения{' '}
                                <span className="text-[#FF0000]">*</span>
                            </label>
                            <HoverTooltip
                                tooltipText={
                                    props.errors?.end_execution_date || ''
                                }
                            >
                                <input
                                    type="date"
                                    className={`form-input user-input-placeholder w-[200px]  ${
                                        props.errors?.end_execution_date
                                            ? 'border border-[#C15C5C] rounded-md p-2'
                                            : ''
                                    }`}
                                    value={
                                        props.contract?.end_execution_date ?? ''
                                    }
                                    onChange={(e) => {
                                        e.target.value == ''
                                            ? props.onEndExecutionDate(null)
                                            : props.onEndExecutionDate(
                                                  e.target.value
                                              )
                                    }}
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                />
                            </HoverTooltip>
                        </div>
                    </div>
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дополнительная информация
                        </label>
                        <textarea
                            className={`form-textarea w-full`}
                            maxLength={2000}
                            rows={3}
                            value={props.contract?.additional_info || ''}
                            onChange={(e) => props.onSubject(e.target.value)}
                        />
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="К исполнению договора должны быть привлечены субподрядчики (соискатели) из числа субъектов малого и (или) среднего предпринимательства"
                                checked={
                                    props.contract.has_subcontractor ?? false
                                }
                                onChange={props.onSubcontractor}
                                disabled={false}
                            />
                        </div>
                    </div>
                    {props.contract?.has_subcontractor ? (
                        <div className="flex flex-col">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Общая стоимость договоров с субподрядчиками
                                (руб.) <span className="text-[#FF0000]">*</span>
                            </label>
                            <MoneyInput
                                value={
                                    props.contract?.subcontractors_total
                                        ? Number(
                                              props.contract
                                                  ?.subcontractors_total
                                          )
                                        : 0
                                }
                                onChange={props.onSubcontractorTotal}
                                className={`form-input w-[200px] ${
                                    props.errors?.subcontractors_total
                                        ? 'border border-[#C15C5C]'
                                        : ''
                                }`}
                            />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </fieldset>
        </Section>
    )
}

export default ContractBaseInfo
